import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=33d4ea4f&scoped=true&"
import script from "./Collections.vue?vue&type=script&lang=js&"
export * from "./Collections.vue?vue&type=script&lang=js&"
import style0 from "./Collections.vue?vue&type=style&index=0&id=33d4ea4f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4ea4f",
  null
  
)

export default component.exports